import _ from 'lodash'

const filters = {
  essentials: {
    cmiNumber: { label: 'CMI #', key: 'c_mi_number', value: '', target: 'study' },
    paceNumber: { label: 'Pace #', key: 'pace_number', value: '', target: 'study' },
    client: { label: 'Client', key: 'client', value: '', target: 'study' },
    product: { label: 'Product', key: 'product_type', value: '', target: 'study' },
    businessUnit: { label: 'B.U.', key: 'product_area', value: '', target: 'study' },
    category: { label: 'Category', key: 'category', value: '', target: 'study' },
    startYear: { label: 'Start year', key: 'year', value: '', target: 'study' },
    endYear: { label: 'End year', key: 'year', value: '', target: 'study' },
    region: { label: 'Region', key: 'region', value: [], target: 'study' },
    country: { label: 'Country', key: 'country', value: '', target: 'study' },
    verified: { label: 'Verified', key: 'verified', value: true, target: 'study' }
  },
  fragranceDetails: {
    fragranceName: { label: 'Fragrance name', key: 'name', value: '', target: 'fragrance' },
    perfumerRefNumber: { label: 'Reference #', key: 'ref_number', value: '', target: 'fragrance' },
    perfumerName: { label: 'Perfumer name', key: 'perfumer_name', value: '', target: 'fragrance' },
    sapNumber: { label: 'SAP #', key: 'code', value: '', target: 'fragrance' },
    family: { label: 'Family', key: 'family', value: '', target: 'fragrance' },
    subfamily: { label: 'Subfamily', key: 'subfamily', value: '', target: 'fragrance' },
    specifier: { label: 'Specifier', key: 'specifier', value: '', target: 'fragrance' },
    methodology: { label: 'Methodology', key: 'methodology', value: '', target: 'fragrance' },
    region: { label: 'Region', key: 'region', value: [], target: 'fragrance' },
    country: { label: 'Country', key: 'country', value: '', target: 'fragrance' },
    creative: { label: 'Creative', key: 'creative', value: undefined, target: 'fragrance' }
  },
  conceptDetails: {
    name: { label: 'Concept name', key: 'name', value: '', target: 'concept' },
    theme: { label: 'Concept theme', key: 'theme', value: '', target: 'concept' },
    ingredient1: { label: 'Ingredient 1', key: 'ingredient_1', value: '', target: 'concept' },
    ingredient2: { label: 'Ingredient 2', key: 'ingredient_2', value: '', target: 'concept' },
    region: { label: 'Region', key: 'region', value: [], target: 'concept' },
    country: { label: 'Country', key: 'country', value: '', target: 'concept' }
  },
  methodology: {
    designMethod: { label: 'Design method', key: 'design_method', value: '', target: 'study' },
    researchType: { label: 'Research type', key: 'research_type', value: '', target: 'study' },
    cmiTool: { label: 'CMI tool', key: 'cmi_tool_type', value: '', target: 'study' },
    methodology: { label: 'Methodology', key: 'methodology', value: '', target: 'study' },
    objectiveAndStandards: { label: 'Obj. and standards', key: 'objective_and_action_standards', value: '', target: 'study' },
    panelProfile: { label: 'Panel profile', key: 'panel_profile', value: '', target: 'study' }
  },
  demographics: {
    /* bumo: { label: 'BUMO', key: 'bumo', value: '', target: 'study' },
    socialClass: { label: 'Social Class', key: 'social_class', value: '', target: 'study' }, */
    gender: { label: 'Gender', key: 'gender', value: '', target: 'study' },
    ethnicity: { label: 'Ethnicity', key: 'ethnicity', value: '', target: 'study' },
    startAge: { label: 'Lower age limit', key: 'age', value: '', target: 'study' },
    endAge: { label: 'Higher age limit', key: 'age', value: '', target: 'study' }
  },
  metrics: {
    stage: { label: 'Stage', key: 'stage', value: '' },
    order: { label: 'Order', key: 'order', value: '' },
    rdfType: { label: 'RDF type', key: 'rdf_type', value: 'rdf' },
    useConcepts: false,
    threshold: {
      applyThreshold: false,
      amount: 10,
      desc: true,
      type: ''
    },
    metricsList: [{
      applyThreshold: false,
      threshold: { label: 'Threshold on metrics', key: 'threshold', value: { amount: 10, desc: true, type: '' } },
      metricType: { label: 'Metric type', key: 'metric_type', value: '' },
      metric: { label: 'Metric', key: 'metric', value: '' },
      aggregation: { label: 'Aggregation', key: 'aggregation', value: '' },
      confidence: { label: 'Confidence', key: 'confidence', value: false }
    }]
  }
}

const cicsFilters = {
  geographicalType: { label: 'Geographical Type', key: 'geo_type', value: '' },
  geographicalValue: { label: 'Value', key: 'geo_value', value: '' },
  gender: { label: 'Gender', key: 'gender', value: '' },
  question: { label: 'Question', key: 'question', value: '' },
  startAge: { label: 'Lower age limit', key: 'age', value: '' },
  endAge: { label: 'Higher age limit', key: 'age', value: '' }
}

const getInitialFilters = () => {
  return _.cloneDeep(filters)
}

// --- Deep links into Study Search -------------------------------------------
// Another system can link straight into a search with filters pre-filled:
//
//   /search?pace_number=ES-1-2291485031
//   /search?c_mi_number=CMI2024-311&client=Natura
//
// Params are matched against each filter's `key` -- the ES field name -- since
// that is the vocabulary other systems already hold. Anything unrecognised is
// reported back rather than silently dropped, so the caller can tell the user.

// A key can appear in several sections (region/country/name/methodology). A
// bare ?region= should mean the study, not the fragrance or the concept, so
// resolution walks the sections in this order and takes the first hit.
const DEEP_LINK_SECTION_PRECEDENCE = [
  'essentials', 'methodology', 'fragranceDetails', 'conceptDetails',
  'demographics', 'metrics'
]

// `year` and `age` are ranges held as two entries sharing one key.
//   ?year=2026        -> pins both ends to 2026 (that single year)
//   ?year=2020,2026   -> sets the span
const DEEP_LINK_RANGE_KEYS = {
  year: ['startYear', 'endYear'],
  age: ['startAge', 'endAge']
}

const isFilterEntry = (candidate) =>
  _.isPlainObject(candidate) && 'key' in candidate && 'value' in candidate

// Where does this ES field name live in the filter tree?
const resolveDeepLinkTargets = (template, param) => {
  const range = DEEP_LINK_RANGE_KEYS[param]
  if (range) {
    const section = DEEP_LINK_SECTION_PRECEDENCE
      .find(name => template[name] && range.every(entry => template[name][entry]))
    return section ? range.map(entry => [section, entry]) : []
  }
  for (const section of DEEP_LINK_SECTION_PRECEDENCE) {
    const group = template[section]
    if (!group) continue
    const entry = Object.keys(group)
      .find(name => isFilterEntry(group[name]) && group[name].key === param)
    if (entry) return [[section, entry]]
  }
  return []
}

// Coerce a string from the URL into whatever shape the filter expects.
// Returns undefined when the value cannot be understood, so the caller can
// report the param rather than writing nonsense into the filter.
const coerceDeepLinkValue = (template, raw) => {
  if (raw === undefined || raw === null) return undefined
  if (Array.isArray(template.value)) {
    return String(raw).split(',').map(part => part.trim()).filter(Boolean)
  }
  if (typeof template.value === 'boolean') {
    const normalised = String(raw).trim().toLowerCase()
    if (['1', 'true', 'yes'].includes(normalised)) return true
    if (['0', 'false', 'no'].includes(normalised)) return false
    // A typo like ?verified=maybe must not quietly change the result scope.
    return undefined
  }
  return String(raw).trim()
}

// `APAC` is a UI-only roll-up: picking it in the dropdown also selects the
// three sub-regions, and parseDataForSearch drops the roll-up token on the way
// out. A deep link that set region=['APAC'] alone would therefore send an
// empty region list -- looking filtered while matching everything -- so expand
// it here the same way the dropdown does.
// (The sub-region list is currently repeated in several components; worth
// consolidating into one constant separately.)
const APAC_ROLL_UP = 'APAC'
const APAC_SUB_REGIONS = [
  'APAC-South Asia', 'APAC-South East Asia', 'APAC-North Asia'
]

const expandRegionRollUps = (values) =>
  values.includes(APAC_ROLL_UP)
    ? _.uniq([...values, ...APAC_SUB_REGIONS])
    : values

const isUsableDeepLinkValue = (value) => {
  if (Array.isArray(value)) return value.length > 0
  if (typeof value === 'boolean') return true
  return typeof value === 'string' && value.length > 0
}

/**
 * Pre-fill `filters` from a URL query object. Mutates `filters` in place --
 * pass a clone if you need the original.
 *
 * @returns {{applied: Array<{param: string, path: string, value: *}>,
 *            ignored: string[]}}
 */
const applyQueryToFilters = (filters, query = {}) => {
  const applied = []
  const ignored = []

  Object.keys(query).forEach(param => {
    const rawValue = query[param]
    // vue-router hands back an array when a param repeats; take the last.
    const raw = Array.isArray(rawValue) ? rawValue[rawValue.length - 1] : rawValue
    if (raw === undefined || raw === null || String(raw).trim() === '') return

    const targets = resolveDeepLinkTargets(filters, param)
    if (!targets.length) {
      ignored.push(param)
      return
    }

    const parts = String(raw).split(',').map(part => part.trim()).filter(Boolean)
    const resolved = targets.map(([section, entry], idx) => {
      // For a range, one value pins both ends; two values span them.
      const source = targets.length > 1 ? (parts[idx] ?? parts[0]) : String(raw)
      let value = coerceDeepLinkValue(filters[section][entry], source)
      if (filters[section][entry].key === 'region' && Array.isArray(value)) {
        value = expandRegionRollUps(value)
      }
      return { section, entry, value }
    })

    // Report the param rather than applying it if any part is unusable --
    // e.g. ?year=,, or ?verified=maybe. Half-applying a range would be worse
    // than not applying it, and writing an empty value in would trigger a
    // search that looks filtered but is not.
    if (resolved.some(item => !isUsableDeepLinkValue(item.value))) {
      ignored.push(param)
      return
    }

    resolved.forEach(({ section, entry, value }) => {
      filters[section][entry].value = value
      applied.push({ param, path: `${section}.${entry}`, value })
    })
  })

  return { applied, ignored }
}

const getCicsFilters = () => {
  return _.cloneDeep(cicsFilters)
}

const getEmptyMetric = () => {
  return {
    applyThreshold: false,
    threshold: { label: 'Threshold on metrics', key: 'threshold', value: { amount: 10, desc: true, type: '' } },
    metricType: { label: 'Metric type', key: 'metric_type', value: '' },
    metric: { label: 'Metric', key: 'metric', value: '' },
    aggregation: { label: 'Aggregation', key: 'aggregation', value: '' }
  }
}

/*
 * Saved-query payload compaction.
 *
 * A saved query only needs each field's `value`. The surrounding `label`, `key`
 * and `target` are static and already live in the templates above, yet they
 * were persisted on every single field - a typical analytics query serialised
 * to ~2,280 characters, most of it constants. Storing the bare value and
 * recovering the structure from the template on load cuts that to ~730.
 *
 * The template is what disambiguates: a field it describes with a `value` is
 * persisted as that value alone, and anything else (`metrics.threshold`,
 * `metrics.useConcepts`, or a field the template does not know about) is kept
 * whole. Only the keys actually present are walked, so the pruning `saveQuery`
 * does is preserved and the round trip is lossless.
 *
 * The compact shape is tagged with `_v`. Saved searches written before this,
 * and the flat CICS payloads that share these helpers, have no tag and are
 * passed straight through - they take exactly the path they always did.
 */
const SAVED_QUERY_VERSION = 2

const isFieldObject = (value) =>
  value !== null && typeof value === 'object' && !Array.isArray(value)

// A `{ label, key, value, target }` field, as opposed to a bare boolean or a
// settings object that has no `value` of its own.
const describesValueField = (template) =>
  isFieldObject(template) && 'value' in template

// Only the template can tell a list of entries (`metricsList`) apart from a
// field whose value happens to be an array (`country`), so test it first.
const describesEntryList = (template, stored) =>
  Array.isArray(template) && Array.isArray(stored)

const compactField = (template, stored) => {
  if (describesEntryList(template, stored)) {
    return stored.map(entry => compactFieldGroup(template[0], entry))
  }
  if (describesValueField(template) && isFieldObject(stored) && 'value' in stored) {
    return _.cloneDeep(stored.value)
  }
  return _.cloneDeep(stored)
}

const compactFieldGroup = (template, stored) =>
  _.mapValues(stored, (field, key) => compactField(template && template[key], field))

const compactSavedQuery = (filters) => {
  const template = getInitialFilters()
  return {
    ..._.mapValues(filters, (group, category) =>
      compactFieldGroup(template[category], group)),
    _v: SAVED_QUERY_VERSION
  }
}

const isCompactSavedQuery = (parsed) =>
  isFieldObject(parsed) && parsed._v >= SAVED_QUERY_VERSION

/*
 * `search.metadata_query`/`files_query` were VARCHAR(1000) - a normal query
 * compacts to ~950 characters, but the multi-select values are unbounded, so
 * even a modest selection (roughly twenty countries) overflowed it. Widened
 * to TEXT (MySQL max 65,535 bytes) via backend/scripts/migrate_search_table.py
 * (run against both dev and prod, 2026-09-25). Kept a client-side ceiling
 * well under that true limit so a truly pathological query still gets a
 * clear message instead of a raw DB error, without being anywhere near as
 * strict as the old VARCHAR(1000) accidentally was.
 */
const SAVED_QUERY_MAX_LENGTH = 50000

const SAVED_QUERY_TOO_LARGE_MESSAGE =
  'This search has too many selected values to save. Remove some and try again.'

const isSavedQueryTooLarge = (serialisedQuery) =>
  typeof serialisedQuery === 'string' &&
  serialisedQuery.length > SAVED_QUERY_MAX_LENGTH

const expandField = (template, stored) => {
  if (describesEntryList(template, stored)) {
    return stored.map(entry => expandFieldGroup(template[0], entry))
  }
  if (describesValueField(template)) {
    return { ..._.cloneDeep(template), value: _.cloneDeep(stored) }
  }
  return _.cloneDeep(stored)
}

const expandFieldGroup = (template, stored) =>
  _.mapValues(stored, (field, key) => expandField(template && template[key], field))

const expandSavedQuery = (parsed) => {
  if (!isCompactSavedQuery(parsed)) return parsed
  const template = getInitialFilters()
  const expanded = {}
  Object.keys(parsed).forEach(category => {
    if (category === '_v') return
    expanded[category] = expandFieldGroup(template[category], parsed[category])
  })
  return expanded
}

export default {
  getInitialFilters,
  applyQueryToFilters,
  getCicsFilters,
  getEmptyMetric,
  compactSavedQuery,
  expandSavedQuery,
  isCompactSavedQuery,
  isSavedQueryTooLarge,
  SAVED_QUERY_MAX_LENGTH,
  SAVED_QUERY_TOO_LARGE_MESSAGE
}
